export enum PosStatusBadgeTypes {
  offline = 'OFFLINE',
  onlineAndReady = 'ONLINEANDREADY',
  online = 'ONLINE',
}

export enum StoreStatusBadgeTypes {
  lab = 'LAB',
  new = 'NEW',
  temporarilyClosed = 'TEMPORARY',
  permanentlyClosed = 'PERMANENT',
}

export enum BulkEditReportStatus {
  SUCCESS = 'completed',
  IN_PROGRESS = 'inProgress',
  ERROR = 'error',
}
